import { PropsWithChildren } from "react";

import { Box } from "@mui/material";

export function ClientTabActions({ children }: PropsWithChildren) {
  return (
    <Box display={"flex"} justifyContent={"flex-end"} bgcolor={(theme) => theme.palette.fsw["blue-5"]} p={1} gap={2}>
      {children}
    </Box>
  );
}
